import { colors, palette } from 'theme'

export const defaultThemeStyles: { [index: string]: string } = {
    background: palette.neutral[600],
    border: colors.white,
    outerBorder: colors.blackLight,
    textMain: colors.white,
}
